<template>
	<div class="service-locations-printing-card">
		<!-- RO Settings Section -->
		<SectionContainer>
			<!-- Appointment -->
			<template #left>
				<h4>Repair Order Settings</h4>
			</template>
			<template #content>
				<!-- RO Default Advisor -->
				<dl>
					<dd>
						Print Prompt at Close
					</dd>
					<dd>
						Print Authorized Additions form on WO
					</dd>
					<dd>
						WO Tech Info
					</dd>
					<dd>
						Tech Name Format
					</dd>
					<dd>
						Print Barcode
					</dd>
					<dd>
						Invoice Sublet Info
					</dd>
					<dd>
						WO Requires Hat Number
					</dd>
					<dd>
						Internal - Incl GL Trans
					</dd>
				</dl>
				<dl>
					<dt>Invoice Print Deferred Operations</dt>
					<dd>
						Invoice Default Settings
					</dd>
					<dd>
						Invoice Title
					</dd>
					<dd>
						Maintenance Menu
					</dd>
					<dd>
						Multi-Point Inspection
					</dd>
					<dd>
						Repair Order
					</dd>
				</dl>
				<dl>
					<dt>Oil Change</dt>
					<dd>
						Oil Change Label Lines
					</dd>
					<dd>
						Oil Change Label Months
					</dd>
					<dd>
						Oil Change Label Miles
					</dd>
				</dl>
			</template>
		</SectionContainer>
		<!-- Shared Settings Section -->
		<SectionContainer>
			<template #left>
				<h4>Shared Settings</h4>
			</template>
			<template #content>
				<dl>
					<dd>
						Include Extended Service Amount
					</dd>
					<dd>
						Include Warranty Amount
					</dd>
					<dd>
						Invoice Print Labor
					</dd>
					<dd>
						Invoice Tech Info
					</dd>
					<dd>
						Print GM LTW
					</dd>
					<dd>
						Print Internal Part Cost
					</dd>
					<dd>
						WO Requires Email
					</dd>
				</dl>
			</template>
		</SectionContainer>
	</div>
</template>

<script>
import SectionContainer from '@/components/shells/section-container/section-container';

export default {
	name: 'ServiceLocationsPrintingCard',
	components: { SectionContainer }
};
</script>

<style lang="scss" scoped>
.service-locations-printing-card {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 12px;

	&__item {
		display: block;
	}

	.section-header {
		display: inline-block;
	}
}
</style>
